import type { ComputedRef, InjectionKey, MaybeRefOrGetter } from 'vue';
import type { ButtonVariants } from './variants';
import { computed, inject, provide, toValue } from 'vue';

/**
 * What a container can preset for the buttons inside it, alongside the size every control takes
 * from `provideControlDefaults`. A button's own prop always wins.
 */
export interface ButtonDefaults {
    variant?: ButtonVariants['variant']
}

const buttonDefaultsKey: InjectionKey<ComputedRef<ButtonDefaults>> = Symbol('sphButtonDefaults');

export function provideButtonDefaults(defaults: MaybeRefOrGetter<ButtonDefaults>): void {
    provide(buttonDefaultsKey, computed(() => toValue(defaults)));
}

export function useButtonDefaults(): ComputedRef<ButtonDefaults> {
    return inject(buttonDefaultsKey, computed(() => ({})), false);
}
